import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as group from '../group'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: group.RESOURCE.payload.dimension.partialId,
      partialId: group.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: false,
    description: 'Does this category correspond to sponsored activity?',
    isOptional: false,
    name: 'Is Sponsored?',
    partialId: PartialId.Standard.create('is_sponsored'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
